import React, { useState, useEffect } from "react";
import { getFilteredDocuments } from "../data/common";
import InnerCompnents from "../components/innercomponents/innercomponents";

function MechanicalComponents() {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      getFilteredDocuments("products", "category", "==", "Connectors")
        .then((res) => {
          setData(res);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    fetchData();
  }, []);
  return (
    <>
      <div className="container-fluid">
        <InnerCompnents componentsData={data}></InnerCompnents>
      </div>
    </>
  );
}

export default MechanicalComponents;
